/**
 * This is the padding used by MapBox when they render elements on the map.  Use this
 * value to align with their elements.
 */

export const MAPBOX_PADDING = 10;
